<template>
    <b-row :no-gutters="true" id="menuRow">
        <b-col>
          <b-navbar
            toggleable="lg"
            type="dark"
            class="navbar-modern"
          >
            <b-navbar-brand :to="{name:'home'}" variant="dark">
				    
            <h1 class="display-4">
                <b-iconstack>
                    <b-icon stacked icon="x-diamond-fill" scale="0.75" variant="secondary" style="color:#10486A"/>
                    <b-icon stacked icon="check-all" variant="primary"/>
                    
                </b-iconstack>

                <span v-if="!$auth.loading && !$auth.isAuthenticated" class="d-none d-md-inline-block display-5 pl-2" style="color: #ffffff;">
                  Principal Task
                </span>

            </h1>
                
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse" />

            

            <b-collapse
              id="nav-collapse"
              is-nav>

                

              <b-navbar-nav>

                <!-- <b-nav-item-dropdown
					v-if="!$auth.loading && $auth.isAuthenticated">
				
					<template v-slot:button-content>
						<b-icon-graph-up></b-icon-graph-up>&nbsp;
						Analytics
					</template>
					
					<b-dropdown-item :to="{name: 'wordcloud'}">
						Focus
					</b-dropdown-item>

					<b-dropdown-item @click="this.$emit('edit:task')">
						Heatmap
					</b-dropdown-item>

					


				</b-nav-item-dropdown> -->



                

              </b-navbar-nav>

              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                
                <b-nav-form v-if="!$auth.loading && $auth.isAuthenticated">
                  <b-form-input
                    v-model="quickAddTaskTitle"
                    size="sm"
                    class="mr-sm-2"
                    placeholder="Task Title"
                  />
                  <b-button 
                    size="sm" 
                    class="my-2 my-sm-0" 
                    type="button"
                    @click="quickAddTask"
                  >Quick Add</b-button>
                </b-nav-form>

                <b-nav-item-dropdown right>
                  <!-- Using 'button-content' slot -->
                  <template v-slot:button-content>
                    <span v-if="!($store.getters.getUser === null)">
					
                      <b-img 
							
                        :src="$store.getters.getUser.picture" 
                        :rounded="true"
                        width="28px"
                        height="28px"
                        alt="Profile Image"
                      />

                    </span>
					
                    <span v-else>User</span>
					

                  </template>
                  <b-dropdown-item :to="{name: 'profile'}">
                    <b-icon-person />&nbsp; 
                    Profile
                  </b-dropdown-item>
                  <!-- <b-dropdown-item href="#">Sign Out</b-dropdown-item> -->

                  <b-dropdown-item
                    v-if="(!$auth.loading && !$auth.isAuthenticated) || !$auth.isAuthenticated" 
                    :to="{name: 'signup'}"
                  >
					
                    <b-icon-lock /> &nbsp; 
                    Sign In
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-else 
                    href="#"
                    @click="logout()"
                  >
					
                    <b-icon-lock-fill /> &nbsp; 
                    Log Out
                  </b-dropdown-item>

                  <hr/>

                  <b-dropdown-item to="/tour">
                    <b-icon-map />
                    &nbsp; Tour
                  </b-dropdown-item>

                </b-nav-item-dropdown>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>

        </b-col>
        
        
        
        </b-row>
</template>

<script>

import taskOps from '../mixins/taskOps'
import genericOps from '../mixins/genericOps'

export default {
  name: 'Menu',
  mixins: [taskOps, genericOps],
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout({
        returnTo: process.env.VUE_APP_ENV_LOGOUT_URL || 'https://www.principaltask.com'
      });
    }
  }
    
}
</script>

<style>

</style>